import script from "./AppDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./AppDetailView.vue?vue&type=style&index=0&id=819378c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-819378c8"]])

export default __exports__